module.exports = __webpack_public_path__ + "img/may_900.88289ed9.png";